/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OsmBuildingDto } from './OsmBuildingDto';
import {
    OsmBuildingDtoFromJSON,
    OsmBuildingDtoFromJSONTyped,
    OsmBuildingDtoToJSON,
    OsmBuildingDtoToJSONTyped,
} from './OsmBuildingDto';

/**
 * 
 * @export
 * @interface CompanyDto
 */
export interface CompanyDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    rawCompanyData?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    fullAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    addition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    country?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    lat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    lon?: number | null;
    /**
     * 
     * @type {OsmBuildingDto}
     * @memberof CompanyDto
     */
    osmBuilding?: OsmBuildingDto;
}

/**
 * Check if a given object implements the CompanyDto interface.
 */
export function instanceOfCompanyDto(value: object): value is CompanyDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CompanyDtoFromJSON(json: any): CompanyDto {
    return CompanyDtoFromJSONTyped(json, false);
}

export function CompanyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rawCompanyData': json['rawCompanyData'] == null ? undefined : json['rawCompanyData'],
        'fullAddress': json['fullAddress'] == null ? undefined : json['fullAddress'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'addition': json['addition'] == null ? undefined : json['addition'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
        'osmBuilding': json['osmBuilding'] == null ? undefined : OsmBuildingDtoFromJSON(json['osmBuilding']),
    };
}

export function CompanyDtoToJSON(json: any): CompanyDto {
    return CompanyDtoToJSONTyped(json, false);
}

export function CompanyDtoToJSONTyped(value?: CompanyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'rawCompanyData': value['rawCompanyData'],
        'fullAddress': value['fullAddress'],
        'street': value['street'],
        'number': value['number'],
        'addition': value['addition'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'country': value['country'],
        'lat': value['lat'],
        'lon': value['lon'],
        'osmBuilding': OsmBuildingDtoToJSON(value['osmBuilding']),
    };
}

